import { useEffect } from "react";
import CollapseTable from "../../components/tables/CollapseTable";
import { useFirebase } from "../../hooks/firebase/useFirebase";
import { NOTIFICATIONS_API } from "../../constants/api";
import { orderBy, query } from "firebase/firestore";
import { kTimestamp } from "../../constants/strings";
import { useNotifications } from "../../hooks/notifications/useNotifications";
import {
  getDefaultLimit,
  usePagination,
} from "../../hooks/pagination/usePagination";

export const NotificationsRegister = () => {
  const { tableColumns, tableData } = useNotifications();

  const baseQuery = query(
    NOTIFICATIONS_API,
    orderBy(kTimestamp, "desc"),
    getDefaultLimit()
  );

  const {
    fetchMore,
    paginatedList: notifications,
    getList: getNotifications,
    loading,
  } = usePagination(baseQuery);

  useEffect(() => {
    getNotifications();
  }, []);

  return (
    <div>
      <CollapseTable
        loading={loading}
        columns={tableColumns}
        rows={tableData(notifications)}
        fetchMore={fetchMore}
      />
    </div>
  );
};
